import React from "react";
import { motion } from "framer-motion";

const stats = [
  { v: "100", label: "Мест" },
  { v: "9", label: "Произведений" },
  { v: "∞", label: "Эмоций" },
];

export default function AboutShow() {
  return (
    <section
      id="show"
      aria-label="О событии"
      itemScope
      itemType="https://schema.org/Event"
      className="relative py-16 lg:py-24 overflow-hidden"
      data-testid="about-show-section"
    >
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/4861059/pexels-photo-4861059.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "sepia(1) hue-rotate(340deg)",
        }}
      />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 80% 50%, rgba(229,115,36,0.12) 0%, rgba(8,6,5,0) 60%)",
        }}
      />

      <div className="container-custom grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-20 relative">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1 }}
          className="md:col-span-5"
        >
          <span className="eyebrow mb-6 block" role="presentation">· О событии</span>
          <h2
            className="font-serif font-light leading-[1.02] tracking-tight"
            style={{ fontSize: "clamp(2.4rem, 5vw, 4.5rem)", color: "#F2E9DE" }}
            data-testid="about-show-title"
            itemProp="name"
          >
            История,
            <br />
            <em style={{ color: "#E57324" }}>оживающая на сцене</em>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="md:col-span-7 flex flex-col gap-8"
        >
          <blockquote className="text-lg lg:text-xl font-light leading-relaxed tracking-wide text-[#F2E9DE]/90">
            <em className="font-serif text-[#E57324] text-2xl">
              Погружение в эпоху Шопена: иммерсивный концерт-моноспектакль при свечах
            </em>
          </blockquote>
          <p itemProp="description" className="text-base lg:text-lg leading-relaxed text-[#A99F96]">
            «Вечные Шопен» — это не просто концерт, это — камерный моноспектакль в самом сердце Москвы. В окружении сотен свечей, под звуки классической музыки, вы становитесь не зрителем, а гостем парижских салонов XIX века и проживаете историю гения вместе с артисткой. Вероника Валова исполняет самые сокровенные ноктюрны, вальсы, баллады и этюды Фридерика Шопена, превращая великие сочинения в живой разговор гения с вашей душой. Без сцены. Без декораций. Только живой рояль, свечи и два века бессмертия.
          </p>
          <p className="text-base lg:text-lg leading-relaxed text-[#A99F96]">
            Вас ждет уникальный формат 360°, где музыка, театр и гастрономия театра-ресторана «Наблюдатель» сливаются в один изысканный вечер. Всего 100 мест — идеальный подарок для романтических встреч.
          </p>

          <div className="grid grid-cols-3 gap-6 pt-8 mt-4 border-t border-[#F2E9DE]/10">
            {stats.map((s, i) => (
              <div key={i} data-testid={`stat-${i}`}>
                <div
                  className="font-serif font-light"
                  style={{
                    fontSize: "clamp(2rem, 4vw, 3.2rem)",
                    color: "#E57324",
                  }}
                >
                  {s.v}
                </div>
                <div className="text-[0.6rem] md:text-[0.7rem] tracking-[0.25em] uppercase text-[#A99F96] mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
